import { Image } from "react-bootstrap";

import AustinLogo from "../assets/img/austinlogo.svg";

export const Preloader = ({ show = true }: { show?: boolean }) => (
	<div
		className={`preloader bg-soft  flex-column justify-content-center align-items-center ${
			show ? "" : "show"
		}`}
		data-testid="test-preloader"
	>
		<div className="loader-element animate__animated animate__jackInTheBox">
			<Image className="shimmer " src={AustinLogo} height={75} />
		</div>
		{/* <div className="loader-element mt-3 spinning-loader-large animate__animated animate__jackInTheBox" /> */}

		<span style={{ display: "none" }}>Loading</span>
	</div>
);
